import { excelReportService } from 'app/services/ExcelReportService'
import clsx from 'clsx'
import { FC, useState } from 'react'
import { Button } from '_core'
import { downloadFile } from 'app/utilities/excel'
import { getTimezone } from 'app/utilities'
import cloneDeep from 'lodash/cloneDeep'

type Props = {
  reportType: string
  filter: any
  className: string
  title?: string
  totalCount?: number
  orders?: boolean
}

const ButtonExport: FC<Props> = ({ className, title, ...props }) => {
  const [isSubmitting, setSsSubmitting] = useState(false)

  const handleDownload = async () => {
    try {
      setSsSubmitting(true)
      const newState = cloneDeep(props)
      newState.filter.timezone = getTimezone()
      const data = await excelReportService.download(newState)
      downloadFile(props.reportType, data, props.filter, props.totalCount, props.orders)
    } catch (error) {
      console.error(error)
    } finally {
      setSsSubmitting(false)
    }
  }

  return (
    <Button
      type='button'
      title={title ? title : 'Export'}
      isSubmitting={isSubmitting}
      id='btnExport'
      className={clsx('btn-sm btn-secondary', className)}
      onClick={handleDownload}
    />
  )
}

export default ButtonExport
